import c from '@/styles/TextTitle';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface TextTitleProps extends ComponentProps<'h1'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
}

const TextTitleComponent: Component<TextTitleProps> = ({ className, variant, size, colors, children, ...props }) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('variant', variant, 'default');
  const sizeClassName = getPropStyles('size', size, 'default');
  const colorsClassName = getPropStyles('colors', colors, 'primary');

  const componentClassName = cn(variantClassName, sizeClassName, colorsClassName, className);
  return (
    <h1 className={componentClassName} {...props}>
      {children}
    </h1>
  );
};

export const TextTitle = TextTitleComponent;
